import React from 'react';
import "./CustomToast.css"
const CustomToast = ({ title, content }) => (
    <div className='flex flex-col items-start justify-center  w-fit pl-2.5'>
        <strong>{title}</strong>
        <div className='text-[15px]'>{content}</div>
    </div>
);

export default CustomToast;

export const customToatStyle = {
    position: 'top-center',
    className:"Customtoastpop",
    autoClose: false,
    hideProgressBar: true,
    closeOnClick: false,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    style: { background: 'linear-gradient(90deg , #2f3034, #3b3d49)', color: '#fff', outline: '1px solid  rgba(84, 96, 108, 1)', borderRadius: '16px', width: 'fit-content',position: 'fixed',
    left: '50%', },
}
export const customToatStyleError = {
    position: 'top-center',
    className:"Customtoastpop",
    autoClose: false,
    hideProgressBar: true,
    closeOnClick: false,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    progressStyle: { background: "#DBDBDB" },
    theme: "colored",
    style: { background: 'linear-gradient(90deg , #2f3034, #3b3d49)', color: '#fff', width: '480px', outline: '1px solid  rgba(84, 96, 108, 1)', borderRadius: '16px' , paddingRight:"14px" , position: 'fixed',
    left: '50%',},
}
